<template>
  <!-- Dashboard Sidebar
	================================================== -->
  <div class="dashboard-sidebar">
    <div class="dashboard-sidebar-inner" data-simplebar>
      <div class="dashboard-nav-container">
        <!-- Responsive Navigation Trigger -->
        <a href="#" class="dashboard-responsive-nav-trigger">
          <span class="hamburger hamburger--collapse">
            <span class="hamburger-box">
              <span class="hamburger-inner"></span>
            </span>
          </span>
          <span class="trigger-title">Dashboard Navigation</span>
        </a>

        <!-- Navigation -->
        <div class="dashboard-nav">
          <div class="dashboard-nav-inner">
            <ul data-submenu-title="Start">
              <li
                class=""
                :class="{ active: $route.name === 'AdminDashboard' }"
              >
                <router-link to="/dashboard">
                  <i class="icon-material-outline-dashboard"></i> Dashboard
                </router-link>
              </li>
              <li :class="{ active: $route.name === 'Messages' }">
                <router-link to="/dashboard/messages">
                  <i class="icon-feather-bell"></i> Notifications
                  <span class="nav-tag">2</span>
                </router-link>
              </li>
            </ul>

            <!-- Other -->
            <ul data-submenu-title="Others">
              <li
                :class="{ 'active-submenu': isUserSidebarOpen }"
                @click="isUserSidebarOpen = !isUserSidebarOpen"
              >
                <router-link :to="{ name: AdminAllUsers }"
                  ><i class="icon-material-outline-group"></i>
                  Users</router-link
                >
                <ul>
                  <li>
                    <router-link to="/dashboard/jobs/postnewjob"
                      >Post a job</router-link
                    >
                  </li>
                  <li><a href="/dashboard/jobs/allmyjobs">All your jobs</a></li>
                  <li><a href="/dashboard/jobs/draftprojects">Drafts</a></li>
                </ul>
              </li>
              <li
                :class="{ 'active-submenu': isProjectsSidebarOpen }"
                @click="isProjectsSidebarOpen = !isProjectsSidebarOpen"
              >
                <a href="#"
                  ><i class="icon-material-outline-assignment"></i> Projects</a
                >
                <ul>
                  <li><router-link to="/admin/projects/all">All Projects</router-link></li>
                  <li><router-link to="/admin/projects/drafts">Draft Projects</router-link></li>
                  <li><router-link to="/admin/projects/published">Published Projects</router-link></li>
                  <li><router-link to="/admin/projects/started">Started Projects</router-link></li>
                  <li><router-link to="/admin/projects/completed">Completed Projects</router-link></li>
                  <li><router-link to="/admin/projects/cancelled">Cancelled Projects</router-link></li>
                  <li><router-link to="/admin/projects/deleted">Deleted Projects</router-link></li>
                </ul>
              </li>
              <li
                :class="{ 'active-submenu': isProjectsAppSidebarOpen }"
                @click="isProjectsAppSidebarOpen = !isProjectsAppSidebarOpen"
              >
                <a href="#"
                  ><i class="icon-material-outline-business"></i> Project
                  Applications</a
                >
                <ul>
                  <li><a href="#">Manage Applications</a></li>
                  <li><a href="#">Manage Applications</a></li>
                  <li><a href="#">Manage Applications</a></li>
                </ul>
              </li>
              <li
                :class="{ 'active-submenu': isPaymentsSidebarOpen }"
                @click="isPaymentsSidebarOpen = !isPaymentsSidebarOpen"
              >
                <a href="#"
                  ><i class="icon-material-outline-account-balance-wallet"></i>
                  Payments</a
                >
                <ul>
                  <li><a href="#">Manage Applications</a></li>
                  <li><a href="#">Manage Applications</a></li>
                  <li><a href="#">Manage Applications</a></li>
                </ul>
              </li>
              <li
                  :class="{ 'active-submenu': isLocationsSidebarOpen }"
                  @click="isLocationsSidebarOpen = !isLocationsSidebarOpen"
              ><a href="#"><i class="icon-material-outline-location-on"></i> Locations</a>
                <ul>
                  <li><router-link to="/admin/location/countries">Countries</router-link></li>
                  <li><router-link to="/admin/location/regions">Regions</router-link></li>
                </ul>
              </li>
            </ul>

            <ul data-submenu-title="Account">
              <li>
                <a href="#"
                  ><i class="icon-material-outline-settings"></i> Settings</a
                >
              </li>
              <li>
                <a href="#"
                  ><i class="icon-material-outline-power-settings-new"></i>
                  Logout</a
                >
              </li>
            </ul>
          </div>
        </div>
        <!-- Navigation / End -->
      </div>
    </div>
  </div>
  <!-- Dashboard Sidebar / End -->
</template>

<script>
export default {
  name: "AppSidebar",
  data: function() {
    return {
      isUserSidebarOpen: false,
      isProjectsSidebarOpen: false,
      isProjectsAppSidebarOpen: false,
      isPaymentsSidebarOpen: false,
      isLocationsSidebarOpen: false,
    };
  },
};
</script>

<style scoped>
  .dashboard-nav ul li.active-submenu ul {
    max-height: 300px;
  }
</style>
